import { HttpGet } from "../utils/request";

export function multiFlowListData(ticker, date) {
     return HttpGet(`/api/v3/mfsummary?ticker=${ticker}&date=${date}`)
}
